import axios from "axios";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import styled from "styled-components";
import { ButtonPrimary } from "../../components/buttonStyles/style";
import { Input } from "../../components/Inputs";
import { H5, LoadingIcon, TextBold } from "../../components/textStyles/style";

let Height = "calc(100vh - clamp(54px, 8vw, 84px) - 62px)";

const Wrapper = styled.div`
  width: 100vw;
  min-height: ${Height};
  display: flex;
  justify-content: center;
`;
const ContentWrapper = styled.div`
  background-color: white;
  width: 90%;
  padding: 30px;
  border-radius: 20px;
  margin: 30px 0;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-top: 20px;
`;

const NewEpisode = () => {
  const history = useHistory();
  const { i18n } = useTranslation();
  const { season_code } = useParams();
  const [code, setCode] = useState("");

  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");

  const [duration, setDuration] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [workshopCode, setWorkshopCode] = useState("");

  const submitHandler = async () => {
    setLoading(true);
    setErrorMessage("");
    const TOKEN = localStorage.getItem("TOKEN");

    // simple checker

    var codeChecker = code.split("-");
    if (
      codeChecker[0].length !== 4 ||
      codeChecker[1].length !== 4 ||
      codeChecker[2].length !== 2 ||
      codeChecker[3].length !== 2 ||
      codeChecker[4].length !== 1 ||
      codeChecker[5].length !== 2
    ) {
      setLoading(false);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setErrorMessage("code episode invalid");
    } else if (duration <= 0) {
      setLoading(false);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setErrorMessage("code episode invalid");
    } else {
      try {
        const data = {
          access_token: TOKEN,
          episode_code: code,
          season_code,
          language: i18n.language,
          title,
          link,
          duration,
          workshop_code: workshopCode,
        };

        await axios.post(process.env.REACT_APP_NEW_EPISODE, data);
        setLoading(false);
        history.goBack();
      } catch (error) {
        setLoading(false);
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        if (error.response.status === 400) {
          setErrorMessage(
            "Données Invalides, Veuillez remplir tous les champs"
          );
        } else if (error.response.status === 409) {
          setErrorMessage("Une Episode existe avec le code fourni");
        } else {
          setErrorMessage("Probléme de Connexion");
        }
      }
    }
  };

  return (
    <Wrapper>
      <ContentWrapper>
        <H5>New Episode</H5>
        <Row>
          <TextBold color="#c22222">
            {errorMessage ? errorMessage : " "}
          </TextBold>
        </Row>
        {/** Episode code + title */}
        <Row>
          <Input
            placeholder="Episode Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <Input
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Row>

        {/** link */}
        <Row>
          <Input
            placeholder="Audio/Vidéo Link"
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
        </Row>

        {/** duration  */}
        <Row>
          <Input
            placeholder="Duration"
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
          />
        </Row>
        {/** workshop code */}
        <Row>
          <Input
            placeholder="Movement  (Workshop Code)"
            value={workshopCode}
            onChange={(e) => setWorkshopCode(e.target.value)}
          />
        </Row>

        <Row style={{ marginTop: 40 }}>
          <ButtonPrimary onClick={submitHandler}>
            {loading ? <LoadingIcon color="inherit" /> : "Add New Episode"}
          </ButtonPrimary>
        </Row>
      </ContentWrapper>
    </Wrapper>
  );
};

export default NewEpisode;
